/**
 * Shared Leaflet utilities used by gpxMap.js and pointsMap.js.
 */

let leafletPromise = null;

export function loadLeaflet() {
  if (!leafletPromise) {
    leafletPromise = Promise.all([
      import("leaflet"),
      import("leaflet/dist/leaflet.css"),
    ]).then(([L]) => L.default || L);
  }
  return leafletPromise;
}

export function createBaseLayers(L, ignKey) {
  const openTopo = L.tileLayer(
    "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    {
      maxZoom: 17,
      attribution:
        'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>, SRTM | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
    },
  );

  const osm = L.tileLayer(
    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    },
  );

  const ignPlanV2 = L.tileLayer(
    "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
    {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.ign.fr">IGN</a>',
    },
  );

  const baseLayers = {
    OpenTopoMap: openTopo,
    OpenStreetMap: osm,
    "IGN Plan": ignPlanV2,
  };

  if (ignKey) {
    baseLayers["IGN Scan25"] = L.tileLayer(
      `https://data.geopf.fr/private/wmts?apikey=${ignKey}&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.MAPS&STYLE=normal&FORMAT=image/jpeg&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}`,
      {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.ign.fr">IGN</a> Scan25',
      },
    );
  }

  return { baseLayers, defaultLayer: openTopo };
}
